import React, { Component, Fragment } from "react";
import "./PaymentModule.scss";

import api from "../../util/api";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { connect } from "react-redux";
import { Util } from "../../util/util";
import { Modal, ModalBody } from 'reactstrap';
import { getTranslatedText as t } from "../../translations/index";
import { Route } from "react-router";
import { Link } from "react-router-dom";
import PaymentSuccessful from "../../shared/PaymentSuccessful";
import PaymentFailed from "../../shared/PaymentFailed";
import VerificationModal from "../PaymentModule/VerificationModal";
import jsPDF from 'jspdf';
import bill from '../../assets/images/receipt.png';
import refresh from '../../assets/images/refresh.svg';
import { indexOf } from "lodash";

class PaymentModule extends Component {
  state = {
    isStatusAvailable: false,
    allOpenChecks: "",
    myTotalAmount: "",
    myOpenChecks: [],
    restaurantCode: "",
    tableNumber: "",
    storedChecks: "",
    myTableAmt: 0,
    myDate: "",
    accessToken: "",
    myChecks: [],
    simplifiedOpenChecks: [],
    tableChecks: [],
    checksInProcess: [],
    noChecks: "",
    paymentUrl: "",
    isPaymentGatewayVisible: false,
    isPaymentSuccessfulVisible: false,
    isPaymentFailedVisible: false,
    tip: "",
    authCode: "",
    isPaymentHistoryVisible: false,
    isOpenCheckListVisible: true,
    isPayInRoom: false,
    selectedIndex: -1,
    mySelectedIndex: -1,
    tipAmount: "",
    checks: [],
  };

  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    let restaurantCode = params.get("rcode");
    let tableNumber = params.get("tn");
    let refId = params.get("ref");
    this.setState(
      {
        restaurantCode,
        tableNumber,
      },
      () => {
        if (refId) {
          let checksInProcess = JSON.parse(
            localStorage.getItem(
              this.state.restaurantCode +
              this.state.tableNumber +
              "PaymentProcessing"
            )
          );
          this.closePaidChecks(checksInProcess, refId);
        }
      }
    );
    if (localStorage.getItem(`${restaurantCode}${tableNumber}Orders`)) {
      let storedChecks = JSON.parse(
        localStorage.getItem(`${restaurantCode}${tableNumber}Orders`)
      );
      this.setState({ storedChecks });
    }
  }

  closePaidChecks = (checksInProcess, refId) => {
    let total = 0;
    trackPromise(
      axios
        .post(
          `${api.orderUrl}${this.state.restaurantCode}/process-payment`,
          {
            table_number: this.state.tableNumber,
            payment_reference_no: refId,
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": api.orderApiSubscriptionKey,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            let paidChecks = [];
            if (localStorage.getItem(`paidChecks${this.state.restaurantCode}${this.state.tableNumber}`)) {
              paidChecks = JSON.parse(localStorage.getItem(`paidChecks${this.state.restaurantCode}${this.state.tableNumber}`))
              res.data.processed_checks.map((data, index) => {
                if (data.status === "paid") {
                  paidChecks.push(data);
                }
              })
              localStorage.setItem(`paidChecks${this.state.restaurantCode}${this.state.tableNumber}`, JSON.stringify(paidChecks));
            } else {
              res.data.processed_checks.map((data, index) => {
                if (data.status === "paid") {
                  paidChecks.push(data);
                }
              })
              localStorage.setItem(`paidChecks${this.state.restaurantCode}${this.state.tableNumber}`, JSON.stringify(paidChecks));
            }

            localStorage.removeItem(
              this.state.restaurantCode +
              this.state.tableNumber +
              "PaymentProcessing"
            );
            this.setState({
              isPaymentSuccessfulVisible: true,
              authCode: res.data.auth_code,
            })
          }
        })
        .catch((err) => {
          this.setState({
            isPaymentFailedVisible: true
          })
          // Util.ok(`${t("ERROR")}`, `${t("WENT_WRONG")}`, `${t("OK_BTN")}`, () =>
          //   console.log("error")
          // );
        })
    );
  };

  getCheckStatus = () => {
    trackPromise(
      axios
        .get(
          api.orderUrl +
          `${this.state.restaurantCode}/checks?table_number=${this.state.tableNumber}`,
          {
            headers: {
              "Content-Type": "application/json",
              "Ocp-Apim-Subscription-Key": api.orderApiSubscriptionKey,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.data.checks && res.data.checks.length > 0) {
              this.setState(
                {
                  isStatusAvailable: true,
                  allOpenChecks: res.data.checks,
                },
                () => {
                  this.getMyChecks();
                }
              );
            } else {
              this.setState({
                isStatusAvailable: true,
                allOpenChecks: [],
              });
            }
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.status) {
            if (err.response.status === 401) {
              if (err.response.data.error.code === 700) {
                Util.ok(
                  `${t("UNAUTHORISED_MSG")}`,
                  `${t("NAME_MISMATCH")}`,
                  `${t("OK_BTN")}`,
                  () => console.log("error")
                );
              } else if (err.response.data.error.code === 702) {
                Util.ok(
                  `${t("UNAUTHORISED_MSG")}`,
                  `${t("UNAUTHORISED")}`,
                  `${t("OK_BTN")}`,
                  () => console.log("error")
                );
              }
            } else if (err.response.status === 500) {
              Util.ok(
                `${t("ERROR")}`,
                `${t("WENT_WRONG")}`,
                `${t("OK_BTN")}`,
                () => console.log("error", err.response)
              );
            } else if (err.response.status === 403) {
              if (err.response.data.error.code === 701) {
                Util.ok(
                  `${t("FORBIDDEN")}`,
                  `${t("RESTAURANT_NOT_OPEN")}`,
                  `${t("OK_BTN")}`,
                  () => {
                    window.location.href =
                      "/?rcode=" +
                      this.state.resCode +
                      "&tn=" +
                      new URLSearchParams(window.location.search).get("tn");
                  }
                );
              }
            } else {
              Util.ok(
                `${t("ERROR")}`,
                `${t("WENT_WRONG")}`,
                `${t("OK_BTN")}`,
                () => console.log("error")
              );
            }
          } else {
            Util.ok(
              `${t("ERROR")}`,
              `${t("WENT_WRONG")}`,
              `${t("OK_BTN")}`,
              () => console.log("error")
            );
          }
        })
    );
  };

  getMyChecks = () => {
    let myChecks = [],
      simplifiedOpenChecks = [],
      tableChecks = [];
    this.state.allOpenChecks &&
      this.state.allOpenChecks.map((data) => {
        if (this.state.storedChecks) {
          let myCheckFlag = false, myCheckDetail = [];
          data && data.order_detail && data.order_detail.map((data2) => {
            if (data2.includes("Online Order")) {
              myCheckFlag = true;
            } else if (data2.includes("Total Due")) {
              myCheckFlag = false;
            }
            if (myCheckFlag) {
              myCheckDetail.push(data2);
            }
          })
          if (data.check_number === this.state.storedChecks[this.state.storedChecks.length - 1].orderDetails.check_number) {
            let a = {
              check_number: data.check_number,
              amount: data.amount,
              checkDetails: myCheckDetail
            };
            myChecks.push(a);
          } else {
            let checkFlag = false, checkDetail = [];
            data && data.order_detail && data.order_detail.map((data2) => {
              if (data2.includes("Online Order")) {
                checkFlag = true;
              } else if (data2.includes("Total Due")) {
                checkFlag = false;
              }
              if (checkFlag) {
                checkDetail.push(data2);
              }
            })
            let b = {
              check_number: data.check_number,
              amount: data.amount,
              checkDetails: checkDetail,
            };
            tableChecks.push(b);
          }
        } else {
          let checkFlag = false, checkDetail = [];
          data && data.order_detail && data.order_detail.map((data2) => {
            if (data2.includes("Online Order")) {
              checkFlag = true;
            } else if (data2.includes("Total Due")) {
              checkFlag = false;
            }
            if (checkFlag) {
              checkDetail.push(data2);
            }
          })
          let b = {
            check_number: data.check_number,
            amount: data.amount,
            checkDetails: checkDetail,
          };
          tableChecks.push(b);
        }
      });


    this.state.allOpenChecks &&
      this.state.allOpenChecks.map((data) => {
        let a = {
          check_number: data.check_number,
          amount: data.amount,
        };
        simplifiedOpenChecks.push(a);
      });

    let myTableAmt =
      myChecks &&
      myChecks[myChecks.length - 1] &&
      myChecks[myChecks.length - 1].amount;
    this.setState({ myTableAmt, myChecks, simplifiedOpenChecks, tableChecks });
  };

  createOrder = (amount, checks, currencyCode, firstName, lastName, emailId) => {
    checks.map((data) => {
      delete data["checkDetails"];
    })
    localStorage.setItem(
      this.state.restaurantCode + this.state.tableNumber + "PaymentProcessing",
      JSON.stringify(checks)
    );
    let windowUrl = window.location.href;
    let redirectUrl = "";
    let params = new URLSearchParams(window.location.search);
    let httpsIndex = windowUrl.indexOf("https");
    let restaurantCode1 = params.get("rcode");
    let restaurantCode2 = params.get("tn");
    if (httpsIndex === 0) {
      redirectUrl = windowUrl.substring(8,);
    } else {
      redirectUrl = windowUrl.substring(7,);
    }
    // if(restaurantCode1?.toUpperCase() === "AQPOOL" || restaurantCode1?.toUpperCase() === "AQBEACH"){
    if (
      // restaurantCode1?.toUpperCase() != "JPSINFY"
      // && restaurantCode1?.toUpperCase() != "JPSSTP"
      // && restaurantCode1?.toUpperCase() != "JPSPDR"
      // && restaurantCode1?.toUpperCase() != "JCTPDR"
      // && restaurantCode1?.toUpperCase() != "JMBMNT"
      // && restaurantCode1?.toUpperCase() != "JFHPDR"
      // && !restaurantCode1?.includes("PDR")
      // restaurantCode1?.toUpperCase() !== "JPSINFY"
      // && restaurantCode1?.toUpperCase() !== "JPSSTP"
      // && restaurantCode1?.toUpperCase() !== "JPSPDR"
      // restaurantCode1?.toUpperCase() !== "BAAPDR"
      restaurantCode1?.toUpperCase() !== "BAAPDRSS"
      // && restaurantCode1?.toUpperCase() !== "JCTPDR"
    ) {
      // https://emenu.jumeirah.com/emenu-latest/#/?rcode=AQPOOL&tn=1
      //  = ${api.redirect_urls}
      redirectUrl = `${api.redirect_urls}/emenu-latest/#/?rcode=${restaurantCode1}&tn=${restaurantCode2}`;
    }
    trackPromise(
      axios
        .post(
          `${api.orderUrl}${this.state.restaurantCode}/start-payment`,
          {
            tip_amount: amount,
            table_number: this.state.tableNumber,
            currency_code: currencyCode,
            //redirect_url: redirectUrl,
            // redirect_url: `${api.redirect_urls}/?rcode=${rcode}&tn=${tn}`,
            redirect_url: `${api.redirect_urls}/?${restaurantCode1}&tn=${restaurantCode2}`,
            checks: checks,
            first_name: firstName,
            last_name: lastName,
            email_id: emailId
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": api.orderApiSubscriptionKey,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            if (res && res.data && res.data.payment_url) {
              this.setState({
                paymentUrl: res.data.payment_url + "&slim=true",
                isPaymentGatewayVisible: true
              })
            }
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.status) {
            if (err.response.status === 401) {
              if (err.response.data.error.code === 700) {
                Util.ok(
                  `${t("UNAUTHORISED_MSG")}`,
                  `${t("NAME_MISMATCH")}`,
                  `${t("OK_BTN")}`,
                  () => console.log("error")
                );
              } else if (err.response.data.error.code === 702) {
                Util.ok(
                  `${t("UNAUTHORISED_MSG")}`,
                  `${t("UNAUTHORISED")}`,
                  `${t("OK_BTN")}`,
                  () => console.log("error")
                );
              }
            } else if (err.response.status === 500) {
              Util.ok(
                `${t("ERROR")}`,
                `${t("WENT_WRONG")}`,
                `${t("OK_BTN")}`,
                () => console.log("error", err.response)
              );
            } else if (err.response.status === 403) {
              if (err.response.data.error.code === 701) {
                Util.ok(
                  `${t("FORBIDDEN")}`,
                  `${t("RESTAURANT_NOT_OPEN")}`,
                  `${t("OK_BTN")}`,
                  () => {
                    window.location.href =
                      "/?rcode=" +
                      this.state.resCode +
                      "&tn=" +
                      new URLSearchParams(window.location.search).get("tn");
                  }
                );
              }
            } else {
              Util.ok(
                `${t("ERROR")}`,
                `${t("WENT_WRONG")}`,
                `${t("OK_BTN")}`,
                () => console.log("error")
              );
            }
          } else {
            Util.ok(
              `${t("ERROR")}`,
              `${t("WENT_WRONG")}`,
              `${t("OK_BTN")}`,
              () => console.log("error")
            );
          }
        })
    );
  };

  generateReceipt = (receipt, check_number) => {
    var doc = new jsPDF('p', 'pt');
    doc.setFont('courier');
    doc.setFontSize(16);
    receipt.map((data, index) => {
      doc.text(100, 60 + (index * 26), data);
    })
    doc.save('receipt_' + `${check_number}` + '.pdf');
  }

  closePaymentGateway = () => {
    this.setState({
      isPaymentGatewayVisible: false
    },
      () => {
        window.top.location.href =
          "/?rcode=" +
          this.state.restaurantCode +
          "&tn=" +
          this.state.tableNumber;
      })
  }

  closePaymentSuccessful = () => {
    trackPromise(
      this.setState({ isPaymentSuccessfulVisible: false }, () => {
        window.top.location.href =
          "/?rcode=" +
          this.state.restaurantCode +
          "&tn=" +
          this.state.tableNumber;
      })
    )
  }
  closePaymentFailed = () => {
    trackPromise(
      this.setState({ isPaymentFailedVisible: false }, () => {
        window.top.location.href =
          "/?rcode=" +
          this.state.restaurantCode +
          "&tn=" +
          this.state.tableNumber;
      })
    )
  }
  handleTipInputChange = (e) => {
    if (e.target.value >= 0) {
      this.setState({ [e.target.name]: e.target.value });
    }
  };
  showPaymentHistory = () => {
    this.setState(prevState => ({ isPaymentHistoryVisible: !prevState.isPaymentHistoryVisible }));
  }
  payInRoom = (tipAmount, checks) => {
    this.setState(prevState => ({ isPayInRoom: !prevState.isPayInRoom }));
    this.setState({ tipAmount, checks });
  }

  expandCheck = (index) => {
    if (index === this.state.selectedIndex) {
      index = -1;
    }
    this.setState({
      selectedIndex: index,
    });
  }
  expandMyCheck = (index) => {
    if (index === this.state.mySelectedIndex) {
      index = -1;
    }
    this.setState({
      mySelectedIndex: index,
    });
  }

  render() {
    let roomPaymentEnabled = this.props &&
      this.props.infoData &&
      this.props.infoData.payment_to_room_enabled;
    let onlinePaymentEnabled = this.props &&
      this.props.infoData &&
      this.props.infoData.payment_online_enabled;
    let totalAmount = 0;
    let tipAmount = parseInt(this.state.tip);
    if (this.state.tip !== "") {
      totalAmount += tipAmount;
    }
    if (this.state.tip === "") {
      tipAmount = 0;
    }
    let paidCheckList = JSON.parse(localStorage.getItem(`paidChecks${this.state.restaurantCode}${this.state.tableNumber}`));

    return (
      <div className="payment-block">
        <div className="payment-wrapper">
          <div className="payment-heading">Payment</div>
          <div className="menu-hr"></div>
          {paidCheckList &&
            <div className="payment-history">
              <div className="payment-history-list" onClick={this.showPaymentHistory}>
                <h5>Payment History</h5>
                <img className="expand-img" style={{ transform: this.state.isPaymentHistoryVisible ? 'rotate(0deg)' : 'rotate(-90deg)' }} src="data:image/png;base64,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" />
              </div>
              <hr />
              {this.state.isPaymentHistoryVisible &&
                paidCheckList.length > 0 &&
                paidCheckList.map((data, index) => {
                  return (
                    <div className="check-wrapper" key={index}>
                      <div className="check">
                        <div className="date-time-wrapper">
                          <div className="time">Check: {(data.check_number).substring(0, (data.check_number).indexOf("#"))}</div>
                        </div>
                        <div className="price">
                          <span>
                            {this.props.infoData &&
                              this.props.infoData.currency_symbol}{" "}
                            {data.amount}
                          </span>
                        </div>
                        <div className="receipt">
                          <img onClick={() => this.generateReceipt(data.receipt, (data.check_number).substring(0, (data.check_number).indexOf("#")))} style={{ height: '30px', width: '30px', marginTop: '5px' }} src={bill} />
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>}
          {!this.state.isStatusAvailable && (
            <div className="get-status-btn" onClick={this.getCheckStatus}>
              Proceed To Checkout
            </div>
          )}
          {this.state.isStatusAvailable && (
            <Fragment>
              <div className="check-list">
                <div className="open-check-list">
                  <h5>Open Checks</h5>
                  <img className="expand-img" src={refresh} onClick={this.getCheckStatus} />
                </div>
                <hr />

                {
                  this.state.isOpenCheckListVisible &&
                  this.state.allOpenChecks &&
                  this.state.allOpenChecks.length > 0 &&
                  this.state.myChecks &&
                  this.state.myChecks.length > 0 &&
                  this.state.myChecks.map((data, index) => {
                    totalAmount += data.amount;
                    return (
                      <div className="check-wrapper" style={{ backgroundColor: this.state.allOpenChecks.length > 1 ? '#7c6f55' : 'transparent', color: this.state.allOpenChecks.length > 1 ? '#fff' : '#000' }} key={index} onClick={() => this.expandMyCheck(index)}>
                        <div className="check">
                          <div className="date-time-wrapper">
                            <div className="time">Check: {(data.check_number).substring(0, (data.check_number).indexOf("#"))}</div>
                          </div>
                          <div className="price">
                            <span>
                              {this.props.infoData &&
                                this.props.infoData.currency_symbol}{" "}
                              {data.amount}
                            </span>
                          </div>
                          <div className="toggle-button">
                            {this.state.mySelectedIndex === index ?
                              <span class="material-icons">remove</span> :
                              <span className="material-icons">add</span>
                            }
                          </div>
                        </div>
                        {data && data.checkDetails && data.checkDetails.length > 0 &&
                          <div className={`expand-check ${this.state.mySelectedIndex === index ? "" : "shrink"}`}>
                            {data && data.checkDetails.slice(1).map((data1) => {
                              return (
                                <div className="check-details">
                                  <p>{data1}</p>
                                </div>
                              )
                            })}
                          </div>}
                      </div>
                    )
                  })
                }
                {
                  this.state.isOpenCheckListVisible &&
                  this.state.allOpenChecks &&
                  this.state.allOpenChecks.length > 0 &&
                  this.state.tableChecks &&
                  this.state.tableChecks.length > 0 &&
                  this.state.tableChecks.map((data, index) => {
                    totalAmount += data.amount;
                    return (
                      <div className="check-wrapper" style={{ backgroundColor: this.state.allOpenChecks.length > 1 ? '#fff' : 'transparent' }} key={index} onClick={() => this.expandCheck(index)}>
                        <div className="check" key={index}>
                          <div className="date-time-wrapper">
                            <div className="time">Check: {(data.check_number).substring(0, (data.check_number).indexOf("#"))}</div>
                          </div>
                          <div className="price">
                            <span>
                              {this.props.infoData &&
                                this.props.infoData.currency_symbol}{" "}
                              {data.amount}
                            </span>
                          </div>
                          {data && data.checkDetails && data.checkDetails.length > 0 &&
                            <div className="toggle-button">
                              {this.state.selectedIndex === index ?
                                <span class="material-icons">remove</span> :
                                <span className="material-icons">add</span>
                              }
                            </div>}
                        </div>
                        {data && data.checkDetails && data.checkDetails.length > 0 &&
                          <div className={`expand-check ${this.state.selectedIndex === index ? "" : "shrink"}`}>
                            {data && data.checkDetails.slice(1).map((data1) => {
                              return (
                                <div className="check-details">
                                  <p>{data1}</p>
                                </div>
                              )
                            })}
                          </div>}
                      </div>
                    )
                  })
                }
                {
                  this.state.isOpenCheckListVisible &&
                  this.state.allOpenChecks &&
                  this.state.allOpenChecks.length > 0 &&
                  <div className="check-tip">
                    <div className="check-tip-left">
                      Add Tip
                    </div>
                    <div className="check-tip-right">
                      <input
                        type="number"
                        name="tip"
                        placeholder="0"
                        value={this.state.tip}
                        onChange={this.handleTipInputChange}
                      />
                    </div>
                  </div>
                }
                {this.state.isOpenCheckListVisible &&
                  this.state.allOpenChecks &&
                  this.state.allOpenChecks.length === 0 && (
                    <div style={{ fontSize: "20px", textAlign: "center", marginTop: "30px", minHeight: "60px" }}>
                      No Pending Checks on the Table
                    </div>
                  )
                }
              </div>
              {this.state.allOpenChecks && this.state.allOpenChecks.length > 0 && (
                <div className="button-wrapper">
                  {onlinePaymentEnabled &&
                    <div>
                      {this.state.allOpenChecks &&
                        this.state.allOpenChecks.length > 1 &&
                        this.state.myTableAmt && (
                          <div
                            className="pay-for-me-btn"
                            onClick={
                              () => this.payInRoom(
                                tipAmount,
                                this.state.myChecks
                              )
                            }
                          >
                            <span className="label">PAY FOR ME</span>
                            <span className="price">
                              {this.props.infoData &&
                                this.props.infoData.currency_symbol}{" "}
                              {this.state.myTableAmt + tipAmount}
                            </span>
                          </div>
                        )}
                      <div
                        className="pay-for-table-btn"
                        onClick={
                          () => this.payInRoom(
                            tipAmount,
                            this.state.simplifiedOpenChecks
                          )
                        }
                      >
                        <span className="label">
                          {this.state.allOpenChecks &&
                            this.state.allOpenChecks.length === 1
                            ? "PAY"
                            : "PAY FOR TABLE"}
                        </span>
                        <span className="price">
                          {this.props.infoData &&
                            this.props.infoData.currency_symbol}{" "}
                          {totalAmount}
                        </span>
                      </div>
                    </div>
                  }
                  {roomPaymentEnabled && (
                    <div className="button-wrapper">
                      <div style={{ backgroundColor: "rgba(136, 132, 86, 0.47)" }}
                        className="pay-for-table-btn"
                        onClick={this.payInRoom}>
                        <span className="label">CHARGE TO ROOM</span>
                        <span className="price">
                          {this.props.infoData &&
                            this.props.infoData.currency_symbol}{" "}
                          {totalAmount}
                        </span>
                      </div>
                    </div>
                  )}
                  {
                    this.state.isPayInRoom &&
                    <div>
                      <VerificationModal payInRoom={this.payInRoom} createOrder={this.createOrder}
                        tipAmount={this.state.tipAmount} checks={this.state.checks}
                        currencyCode={this.props.infoData && this.props.infoData.currency_symbol}
                      />
                    </div>
                  }
                </div>
              )}
            </Fragment>
          )}
        </div>
        {this.state.isPaymentGatewayVisible &&
          <div className="payment-iframe-block">
            <i className="material-icons" onClick={this.closePaymentGateway}>close</i>
            <iframe className="iframe" src={this.state.paymentUrl} />
          </div>
        }
        {this.state.isPaymentSuccessfulVisible && <PaymentSuccessful closePaymentSuccessful={this.closePaymentSuccessful} authCode={this.state.authCode} />}
        {this.state.isPaymentFailedVisible && <PaymentFailed closePaymentFailed={this.closePaymentFailed} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    infoData: state.infoData,
  };
};

export default connect(mapStateToProps, null)(PaymentModule);
